export default {
    items: [],
    forging: []
}